.section {
  margin-bottom: 16px;
}

.heading {
  font-size: var(--tuna-typography-fontSize-2xl);
  margin-bottom: 4px;
}
